import {initialState} from "../../reduxStore";

const backgroundUtils = {
    getInitialBackgroundMessagesState() {
        return initialState.backgroundMessages;
    }
};

export default backgroundUtils;


// WEBPACK FOOTER //
// ./src/scripts/reusable/BackgroundMessage/BackgroundMessageUtils.js